import { TResponseType } from '@@types/base';
import { TOrderCreate } from '@@types/order';
import apis from '@apis/index';
import queryKeys from '@constants/query-keys';
import {
  useMutation,
  UseMutationOptions,
  useQuery,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { IOrder } from 'interfaces/order';

export const useCreateOrder = (
  options: UseMutationOptions<
    AxiosResponse<TResponseType<IOrder>>,
    unknown,
    TOrderCreate
  >,
) => useMutation(apis.order.createOrder, options);

export const fetchCoupons = () =>
  useQuery([...queryKeys.COUPON.ALL], apis.coupon.fetchCoupons);

export const checkStoreOpenStatus = ({
  id,
  begin = '00:00',
  end = '00:00',
}: {
  id: number;
  begin?: string;
  end?: string;
}) =>
  useQuery([...queryKeys.STORE_AVAILABILITY.CHECK, id, begin, end], () =>
    apis.order.checkStoreOpenStatus({ begin, end }),
  );

export const fetchUserMoney = () =>
  useQuery([...queryKeys.USER.MONEY], apis.auth.fetchUserMoney);
